import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export type UsefulMaterialType = {
    id: number
    title: string
    value: string
    image: string
}

export type UsefulMaterialTypeDto = {
    title: string
    value: string
    image: string
}

export const UsefulMaterialTypesApi = createApi({
    reducerPath: 'UsefulMaterialTypesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    tagTypes: ["USEFUL-MATERIAL-TYPE"],
    endpoints: builder => ({
        getUsefulMaterialType: builder.query<UsefulMaterialType, { id: number }>({
            query: id => ({ url: `/useful-materials-types/${id}` }),
            providesTags: ["USEFUL-MATERIAL-TYPE"]
        }),
        getUsefulMaterialTypeByTitle: builder.query<UsefulMaterialType, { title: string }>({
            query: title => ({ url: `/useful-materials-types/title/${title}` }),
            providesTags: ["USEFUL-MATERIAL-TYPE"]
        }),
        getAllUsefulMaterialTypes: builder.query<UsefulMaterialType[], void>({
            query: () => ({ url: '/useful-materials-types' }),
            providesTags: ["USEFUL-MATERIAL-TYPE"]
        }),
        getAllUsefulMaterialTypesEn: builder.query<UsefulMaterialType[], void>({
            query: () => ({ url: '/useful-materials-types?lang=en' }),
            providesTags: ["USEFUL-MATERIAL-TYPE"]
        }),
        createUsefulMaterialType: builder.mutation<any, UsefulMaterialTypeDto>({
            query: (data) => ({ url: `/useful-materials-types`, method: "POST", body: data }),
            invalidatesTags: ["USEFUL-MATERIAL-TYPE"],
        }),
        deleteUsefulMaterialTypesByIds: builder.mutation<any, any>({
            query: (data)=> ({url: `/useful-materials-types/delete-by-ids`, method: "POST", body: data}),
            invalidatesTags: ["USEFUL-MATERIAL-TYPE"],
        }),
        updateUsefulMaterialType: builder.mutation<any, any>({
            query: data => ({ url: `/useful-materials-types/${data.id}`, method: 'PATCH', body: data }),
            invalidatesTags: ["USEFUL-MATERIAL-TYPE"],
        }),
        updateUsefulMaterialTypeEn: builder.mutation<any, any>({
            query: data => ({ url: `/useful-materials-types/en/update/${data.id}`, method: 'PATCH', body: {title: data.title, value: data.value} }),
            invalidatesTags: ["USEFUL-MATERIAL-TYPE"]
        }),
    })
})

export const { useGetUsefulMaterialTypeQuery, useGetAllUsefulMaterialTypesEnQuery, useGetAllUsefulMaterialTypesQuery, useCreateUsefulMaterialTypeMutation, useDeleteUsefulMaterialTypesByIdsMutation, useUpdateUsefulMaterialTypeMutation, useUpdateUsefulMaterialTypeEnMutation } = UsefulMaterialTypesApi
